module.exports = __webpack_public_path__ + "static/media/serv-uni-small.46260c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/serv-uni-small.jpg
// module id = 488
// module chunks = 0